import React from 'react';

const qualityNames = {
  deterministic: 'детерминированная атрибуция',
  probabilistic: 'вероятностная атрибуция',
  unknown: 'метод атрибуции неизвестен',
};
export const isAppMetrica = value => value?.attribution_provider === 'appmetrica';
export function sourceLabel(value) {
  const source = value?.source === 'yandex_direct' ? 'Яндекс.Директ' : value?.source === 'unknown' ? 'Источник не определён' : value?.source || 'Источник не определён';
  return isAppMetrica(value) ? `${source} · ${qualityNames[value.attribution_quality] || qualityNames.unknown}` : source;
}
export function AttributionBreakdown({ coverage }) {
  if (!coverage) return null;
  return <p>Атрибутировано AppMetrica: детерминированно {coverage.deterministic ?? '—'}, вероятностно {coverage.probabilistic ?? '—'}, метод неизвестен {coverage.unknown ?? '—'}. Точная связь с аккаунтом не означает достоверный рекламный источник.</p>;
}
export default function AttributionEvidence({ acquisition }) {
  if (!isAppMetrica(acquisition)) return null;
  const a = acquisition;
  return <details className="mw-disclosure"><summary>{sourceLabel(a)}{a.campaign && ` · кампания ${a.campaign}`}</summary>
    <p>Связь установки с аккаунтом: {a.account_link_method === 'sdk_challenge_exact_ids' ? 'точная, по проверенному идентификатору' : 'не подтверждена'}.</p>
    <p>Определение рекламного источника: AppMetrica, {a.match_type && a.match_type !== 'unknown' ? `${a.match_type} · ` : ''}{qualityNames[a.attribution_quality] || qualityNames.unknown}.</p>
    <p>Происхождение подтверждения: {a.evidence_origin === 'appmetrica_logs_api' ? 'AppMetrica Logs API' : 'не указано'}.</p>
    <p>Время проверки источника: {a.captured_at ? new Date(a.captured_at).toLocaleString('ru-RU') : 'не указано'}.</p>
    <p>Точная связь установки с аккаунтом не делает вероятностный рекламный источник достоверным автоматически.</p>
  </details>;
}
